import { ReactText } from 'react';
import api from '../services/config/api';

interface IParticipantPost {
  solicitacao: {
    id: ReactText;
  };
  user: {
    id: ReactText;
  };
}

export const addParticipant = (data: IParticipantPost) =>
  api.post('/solicitacao-participante', data);

export const getParticipants = (id: ReactText) =>
  api.get<
    {
      id: number;
      solicitacao: any;
      user: {
        name: string;
        id: number;
        email: string;
        enabled?: boolean;
      };
    }[]
  >(`/solicitacao-participante/${id}`);

export const removeParticipant = (id: ReactText) => api.delete(`/solicitacao-participante/${id}`);
